import React, { useMemo } from 'react';
import ResultGroup from './ResultGroup';

function FederatedSearchPage({
  clientFilteredGroups,
  loading,
  error,
  lastMainQuery,
  refineSearchTerm,
  isHighlightingEnabled,
  isSampleHighlightingEnabled,
  onShowDetails,
  expandAllResults
}) {

  const totalDisplayableItems = useMemo(() =>
    Object.values(clientFilteredGroups).reduce((sum, group) => sum + group.length, 0),
    [clientFilteredGroups]
  );

  const renderResultsHeader = () => {
    if (!lastMainQuery || error) return null;
    const queryDisplay = refineSearchTerm ? `"${lastMainQuery}" (refined with "${refineSearchTerm}")` : `"${lastMainQuery}"`;
    if (totalDisplayableItems > 0) return <h2 className="text-xs font-medium mb-4" style={{ color: 'var(--text-faint)' }}>Displaying {totalDisplayableItems} results for {queryDisplay}</h2>;
    if (!loading) return <p className="text-xs font-medium mb-4" style={{ color: 'var(--text-faint)' }}>No specific test results found for {queryDisplay}.</p>;
    return null;
  };

  return (
    <div className="w-full max-w-5xl mx-auto py-5 px-5">
      {error && <p className="text-rose-400/90 text-sm mb-4 p-3 bg-rose-500/10 border border-rose-500/20 rounded-xl">{error}</p>}
      {renderResultsHeader()}
      <div className="flex flex-col gap-2.5">
          {Object.entries(clientFilteredGroups).length > 0 && (
               Object.entries(clientFilteredGroups).sort().map(([groupName, groupResults]) => (
                  <ResultGroup
                    key={groupName}
                    groupName={groupName}
                    results={groupResults}
                    highlightTerm={isHighlightingEnabled ? (refineSearchTerm || lastMainQuery) : ''}
                    isSampleHighlightingEnabled={isSampleHighlightingEnabled}
                    defaultOpen={expandAllResults}
                    onShowDetails={onShowDetails}
                  />
                ))
          )}
      </div>
    </div>
  );
}

export default FederatedSearchPage;